'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/8/5.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceDetailSubmitProductsModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'ServiceDetailSubmitProductsModal',
  fields: ['clientContact', 'clientMobile', 'demand']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceDetailSubmitProductsModal, _Component);

  function ServiceDetailSubmitProductsModal() {
    (0, _classCallCheck3.default)(this, ServiceDetailSubmitProductsModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceDetailSubmitProductsModal).call(this));
  }

  (0, _createClass3.default)(ServiceDetailSubmitProductsModal, [{
    key: 'render',
    value: function render() {
      var styles = require('./ServiceDetailSubmitProductsModal.scss');
      var _props = this.props;
      var _props$fields = _props.fields;
      var clientContact = _props$fields.clientContact;
      var clientMobile = _props$fields.clientMobile;
      var demand = _props$fields.demand;
      var onClose = _props.onClose;
      var handleSubmit = _props.handleSubmit;
      var isOpened = _props.isOpened;
      var headerData = _props.headerData;
      var data = _props.data;

      var customStyle = {
        content: {
          position: 'absolute',
          top: '40px',
          left: '40px',
          bottom: '40px',
          right: '40px',
          border: '1px solid #ccc',
          background: '#fff',
          borderRadius: '4px',
          overflow: 'auto',
          outline: 'none',
          padding: '20px',
          zIndex: 9999
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'form',
          { className: styles.component },
          '购买产品：',
          _react2.default.createElement('br', null),
          data instanceof Array ? data.map(function (productInfo) {
            return _react2.default.createElement(
              'div',
              { key: productInfo.productId, className: styles.item },
              _react2.default.createElement(
                'span',
                { className: styles.price },
                productInfo.productPrice
              ),
              _react2.default.createElement(
                'span',
                { className: styles.name },
                productInfo.productName
              ),
              _react2.default.createElement(
                'span',
                { className: styles.content },
                productInfo.productDescribe
              ),
              _react2.default.createElement('div', { className: 'clear' })
            );
          }) : '',
          '商户信息：',
          _react2.default.createElement('br', null),
          headerData instanceof Array && headerData.length > 0 ? _react2.default.createElement(
            'div',
            null,
            '商户联系人：',
            headerData[0].shopContact,
            _react2.default.createElement('br', null),
            ' 联系电话：',
            headerData[0].shopMobile
          ) : '',
          '客户信息：',
          _react2.default.createElement('br', null),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '联系人：', formProps: clientContact }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '联系电话：', formProps: clientMobile }),
          _react2.default.createElement(_GoeasyInputField2.default, { label: '需求：', formProps: demand }),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: handleSubmit, text: '确定' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: onClose, text: '关闭' })
        )
      );
    }
  }]);
  return ServiceDetailSubmitProductsModal;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  isOpened: _react.PropTypes.bool,
  data: _react.PropTypes.array,
  headerData: _react.PropTypes.array,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ServiceDetailSubmitProductsModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceDetailSubmitProductsModal/ServiceDetailSubmitProductsModal.js
 ** module id = 1414
 ** module chunks = 0
 **/